var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-alert',{attrs:{"dismissible":"","dense":"","border":"left","elevation":"2","colored-border":"","type":_vm.alertType},model:{value:(_vm.activator),callback:function ($$v) {_vm.activator=$$v},expression:"activator"}},[_vm._v(" "+_vm._s(_vm.message)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }